// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/navigation.js
//  _wikiNaviguer · brancherWiki · ouvrirWiki
// ═══════════════════════════════════════════════════════════════════

// ═══════════════════════════════════════════════════════════════════════
//  MODULE WIKI STAFF — FRONTEND
//  À COLLER dans src/App.js juste AVANT  `function Dashboard(...)`.
//
//  Aucun nouvel import : réutilise THEME, API_BASE, useState, useEffect,
//  useRef, useIsMobile et Badge, déjà présents dans App.js.
//
//  Trois branchements dans App.js :
//   1) dans NAV_ITEMS, passer le Wiki à ready: true
//        { id: "wiki", icon: "📚", label: "Wiki Staff", ready: true },
//   2) dans Dashboard(), à côté des autres modules :
//        {activeModule === "wiki" && <Wiki token={token} user={user} onNavigate={setActiveModule} />}
//   3) LOT 2 — dans DashboardHome(), juste après le panneau « 🔧 On y travaille » :
//        <WikiPanel token={token} onNavigate={onNavigate} />
//
//  Version lot 2 (26/07/2026) : duplication de page, brouillon local
//  auto-sauvegardé, corbeille consultable, accusés de lecture, encart
//  Dashboard, export PDF via la version imprimable A4.
// ═══════════════════════════════════════════════════════════════════════

// ── Passerelle de navigation (lot 3) ──────────────────────────────────
//  N'importe quel composant d'App.js peut demander l'ouverture du wiki
//  sans qu'on ait à faire descendre onNavigate de composant en composant.
//  Même principe que le cache _highlightSet déjà présent dans App.js.
//  Dashboard() la branche au montage : brancherWiki(naviguer).
export let _wikiNaviguer = null;

export function brancherWiki(fn) { _wikiNaviguer = fn; }

export function ouvrirWiki(cible) {
  if (_wikiNaviguer) _wikiNaviguer("wiki", cible);
  else console.warn("[wiki] navigation non branchée — voir brancherWiki() dans Dashboard()");
}
